import { render } from "./FormStep4.vue?vue&type=template&id=4c461f42&scoped=true"
import script from "./FormStep4.vue?vue&type=script&lang=js"
export * from "./FormStep4.vue?vue&type=script&lang=js"

import "./FormStep4.vue?vue&type=style&index=0&id=4c461f42&lang=scss"
import "./FormStep4.vue?vue&type=style&index=1&id=4c461f42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c461f42"]])

export default __exports__